import { ENV_GSH_APP_HOST } from 'constants/env';

import { TypeRouteId } from './api';

const gshAppHost = ENV_GSH_APP_HOST;

const gshOrderPath = (orderId: TypeRouteId) => `${gshAppHost}/orders/${orderId}`;
const gshJobOfferPath = (jobOfferId: string) => `${gshAppHost}/job-offers/${jobOfferId}`;

export enum GshObject {
  Order = 'GSH::Order',
  JobOffer = 'GSH::JobOffer',
}

export const gshObjectsRoutes = {
  [GshObject.Order]: gshOrderPath,
  [GshObject.JobOffer]: gshJobOfferPath,
};

/** Page to search the object and redirect to it */
export const gshLinksPagePath = (gshObjectCode: string) => `${gshAppHost}/links?search=${gshObjectCode}`;
